"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doubleStruck = {
    0x20: [0, 0, .25],
    0x41: [.701, 0, .722],
    0x42: [.683, 0, .667],
    0x43: [.702, .019, .722],
    0x44: [.683, 0, .722],
    0x45: [.683, 0, .667],
    0x46: [.683, 0, .611],
    0x47: [.702, .019, .778],
    0x48: [.683, 0, .778],
    0x49: [.683, 0, .389],
    0x4A: [.683, .077, .5],
    0x4B: [.683, 0, .778],
    0x4C: [.683, 0, .667],
    0x4D: [.683, 0, .944],
    0x4E: [.683, .02, .722],
    0x4F: [.701, .019, .778],
    0x50: [.683, 0, .611],
    0x51: [.701, .181, .778],
    0x52: [.683, 0, .722],
    0x53: [.702, .012, .556],
    0x54: [.683, 0, .667],
    0x55: [.683, .019, .722],
    0x56: [.683, .02, .722],
    0x57: [.683, .019, 1],
    0x58: [.683, 0, .722],
    0x59: [.683, 0, .722],
    0x5A: [.683, 0, .667],
    0x6B: [.683, 0, .556],
    0xA0: [0, 0, .25],
    0x391: [.698, 0, .869],
    0x392: [.686, 0, .818],
    0x395: [.68, 0, .756],
    0x396: [.686, 0, .703],
    0x397: [.686, 0, .9],
    0x399: [.686, 0, .436],
    0x39A: [.686, 0, .901],
    0x39C: [.686, 0, 1.092],
    0x39D: [.686, 0, .9],
    0x39F: [.696, .01, .864],
    0x3A1: [.686, 0, .786],
    0x3A2: [.696, .01, .894],
    0x3A4: [.675, 0, .8],
    0x3A7: [.686, 0, .869],
    0x3D2: [.697, 0, .894],
    0x3DC: [.68, 0, .724],
    0x2102: [.702, .019, .722],
    0x210D: [.683, 0, .778],
    0x2115: [.683, .02, .722],
    0x2119: [.683, 0, .611],
    0x211A: [.701, .181, .778],
    0x211D: [.683, 0, .722],
    0x2124: [.683, 0, .667],
};
//# sourceMappingURL=double-struck.js.map